import { SET_PORTAL_SELECTED_BRANCH } from './types';

export const setPortalSelectedBranch = (selectedBranchId) => ({
  type: SET_PORTAL_SELECTED_BRANCH,
  payload: { selectedBranchId: selectedBranchId ? String(selectedBranchId) : null },
});

